import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.5 14.5V10.5C3.0621 10.5 4 10.5 5.5 10.5M16.5 2.5L16.5 6.5H12.5M2.50004 11.1031C3.53299 13.68 6.05397 15.5 9.00004 15.5C12.1711 15.5 14.8496 13.3915 15.7102 10.5M2.28992 6.5C3.15047 3.60851 5.82902 1.5 9.00004 1.5C12.0741 1.5 14.6854 3.4816 15.6262 6.23712",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }